export default __webpack_public_path__ + "static/avril_aysha-4581d28cf2f7eadd07222d318d7f21b1.jpg";